export default __webpack_public_path__ + "static/media/mail_2-01.9cae9417.png";